import { render } from "./learningCenterTutorialsTab.vue?vue&type=template&id=54f30660"
import script from "./learningCenterTutorialsTab.vue?vue&type=script&lang=js"
export * from "./learningCenterTutorialsTab.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./learningCenterTutorialsTab.vue?vue&type=style&index=0&id=54f30660&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__